import React from "react";

interface Props {
  message: string;
}

const ErrorBox: React.FC<Props> = ({message}) => {
  return (
    <div className="box error">
      <p>{message}</p>
    </div>
  );
};

export default ErrorBox;
